import script from "./BasicStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicStatus.vue?vue&type=script&setup=true&lang=js"

import "./BasicStatus.vue?vue&type=style&index=0&id=7278d344&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7278d344"]])

export default __exports__